// src/store/slices/statusSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  committee: [],
  ballot: [],
  request: [],
  record: [],
  standard: [],
  standardRecord: [],
};

const draftedSlice = createSlice({
  name: "draftedData",
  initialState,
  reducers: {
    setCommitteeData: (state, action) => {
      state.committee = action.payload;
    },
    setRecordData: (state, action) => {
      state.record = action.payload;
    },
    setStandardData: (state, action) => {
      state.standard = action.payload;
    },
  },
});

export const { setCommitteeData, setRecordData, setStandardData } =
  draftedSlice.actions;
export default draftedSlice.reducer;
